import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

interface UseClientUserRequestPasswordResetProps {
  userId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useClientUserRequestPasswordReset = ({ userId, onSuccess, onError }: UseClientUserRequestPasswordResetProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['clientUsersRequestPasswordReset', userId],
    mutationFn: async () => {
      return await privateAxios.put(`/client/users/${userId}/request_password_reset`);
    },
    onSuccess,
    onError,
  });
};
